import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { deleteCabinCrew } from '../../../../actions';

const CabinCrewDeleteButton = ({
  dispatchDeleteCabinCrew,
  cabinCrewId,
  disabled,
}) => {
  const [showModal, setShowModal] = useState(false);

  const onClickDelete = () => dispatchDeleteCabinCrew({ cabinCrewId });

  const openModal = () => setShowModal(true);

  const closeModal = () => setShowModal(false);

  return (
    <>
      <ConfirmationModal
        show={showModal}
        onClickConfirm={onClickDelete}
        onClickCancel={closeModal}
      />
      <Button color="danger" onClick={openModal} disabled={disabled}>
        <i className="fa fa-trash-o" /> Eliminar
      </Button>
    </>
  );
};

CabinCrewDeleteButton.propTypes = {
  dispatchDeleteCabinCrew: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  cabinCrewId: PropTypes.number.isRequired,
};

CabinCrewDeleteButton.defaultProps = {
  disabled: false,
};

const mapDispatchToProps = {
  dispatchDeleteCabinCrew: deleteCabinCrew,
};

export default connect(null, mapDispatchToProps)(CabinCrewDeleteButton);
